<template>
  <div :class="{dialog}">
    <div class="consult-wrap">
      <div class="close-consult" v-if="dialog" @click="$emit('close')"></div>
      <div class="title">尊敬的客户</div>
      <div class="desc">
        欢迎联系我们的销售经理咨询
      </div>
      <div class="form-wrap"> 
        <div class="form-item" v-for="(item,ind) in contactList" :key="ind">
          <div class="form-icon"></div>
          <div class="item-right">
            <label>{{item.area}}</label>
            <div v-for="(per,index) in item.person" :key="index">{{per.name}} {{per.phone}}</div>
          </div>
        </div>
      </div>
      <Transition enter-active-class="animate__animated animate__fadeInDownBig">
        <div class="message-box" :class="infoStatus" v-if="showInfo">{{infoTxt}}</div>
      </Transition>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contactList: [
        {
          area: '福建区域',
          person: [
            {
              name: '范先生',
              phone: '15060692281'
            }
          ],
        },
        {
          area: '湖南区域',
          person: [
            {
              name: '段先生',
              phone: '18859196008'
            }
          ],
        },
        {
          area: '四川、重庆区域',
          person: [
            {
              name: '刘先生',
              phone: '18985186546'
            }
          ],
        },
        {
          area: '其他区域',
          person: [
            {
              name: '刘女士',
              phone: '18659195580'
            }
          ],
        },
      ],
      infoTxt: '',
      infoStatus: '',
      showInfo: false,
    }
  },
  watch: {
    infoTxt(newV) {
      if (newV) {
        this.handlerInfo()
      }
    },
  },
  methods: {
    handlerInfo() {
      this.showInfo = true
      setTimeout(() => {
        if (this.infoStatus == 'success') {
          this.$emit('close')
        }
        this.showInfo = false
        this.infoTxt = ''
        this.infoStatus = ''
      }, 2000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util.scss';
.message-box {
  position: fixed;
  width: 220px;
  padding: 10px 20px;
  top: 20px;
  left: calc(50% - 100px);
  border-radius: 4px;
  z-index: 100;
  &.error {
    background-color: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
  }
  &.success {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
}
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.4);
  .consult-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .close-consult {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 32px;
      right: 32px;
      background-image: url('../../public/img/icon_close.png');
      @include bgConfig;
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}
.consult-wrap {
  width: 1200px;
  min-height: 450px;
  max-width: 100%;
  max-height: 100%;
  background-image: url('../../public/img/bg_box@2x.png');
  @include bgConfig;
  background-size: 100% 100%;
  padding: 32px;
  color: #333333;
  .title {
    font-weight: bold;
    font-size: 24px;
  }
  .desc {
    margin: 12px 0 32px;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.5px;
  }
  .form-wrap {
    display: flex;
    flex-wrap: wrap;
    background: #ffffff;
    border-radius: 4px;
    padding: 50px 70px;
    .form-item {
      width: calc((100% - 32px) / 2);
      margin-right: 32px;
      margin-bottom: 40px;
      display: flex;
      .form-icon{
        width: 32px;
        height: 32px;
        background-image: url('../../public/img/icon_phone01.png');
        @include bgConfig;
        margin-right: 24px;
        background-size: 100% 100%;
      }
      .item-right{
        label {
          display: block;
          color: #666666;
          font-size: 16px;
          margin-bottom: 8px;
        }
        div{
          font-size: 20px;
          font-weight: bold;
        }
      }

      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>